<template>
  <div class="user-login-box">
    <h1 class="">移動販売・直売所 スケジュール管理</h1>
    <div class="login">
      <form method="post" @submit.prevent="login" autocomplete="on">
        <label class="label">ユーザー名</label><span class="help is-danger" v-html="e_msg_u_id"></span>
        <p class="control"><input type="text" name="user_id" autocomplete="on" placeholder="ユーザー名" class="input" v-model="user_id"></p>
        <label class="label">パスワード</label><span class="help is-danger" v-html="e_msg_u_pass"></span>
        <input type="password" name="user_pass" autocomplete="on" placeholder="パスワード" class="input" v-model="user_pass">
        <input class="button" type="submit" value="ログイン">
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserLogin',

  // ===========================================================================
  // components
  // ===========================================================================
  components: {
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      e_msg_u_id: '',
      e_msg_u_pass: '',
      user_id: '',
      user_pass: '',
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
    if (this.$route.query.type === 'reload') {
      this.$alert('alert', 'ブラウザがリロードされたため、ログアウトしました。\n再度ログインしてください。');
    } else if (this.$route.query.type === 'useradd') {
      this.$alert('alert', '会員登録を完了しました。\nログインしてください。');
    } else if (this.$route.query.type === 'logout') {
      this.$alert('alert', 'ログアウトしました。');
    }
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    login () {
      let eFlg = false;
      if (!this.user_id) {
        this.e_msg_u_id = 'ユーザー名を入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_id = '';
      }
      if (!this.user_pass) {
        this.e_msg_u_pass = 'パスワードを入力してください';
        eFlg = true;
      } else {
        this.e_msg_u_pass = '';
      }
      if (eFlg === false) {
        let ld = new this.$loader(this);
        ld._data_set({user_id: this.user_id, user_pass: this.user_pass});
        ld._post_cb_f = this.login_cb;
        ld._load_start('/manage/login.php');
        // this.$store.commit('LoginInfo/set_status', 1);
        // this.$router.push({name: 'EditMain', params: {}});
      }
    },
    login_cb (data) {
      if (data.res === 1) {
        this.$store.commit('LoginInfo/set_status', 1);
        this.$store.commit('LoginInfo/set_data', data.data);

        let ld = new this.$loader(this);
        ld._data_set({});
        ld._post_cb_f = this.master_data_get_cb;
        ld._load_start('/manage/holiday_get.php');
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    master_data_get_cb (data) {
      if (data.res === 1) {
        this.$store.commit('Holiday/set_holiday', data.data);
        this.$router.push({name: 'EditMain', params: {}});
      } else {
        this.$alert('alert', `エラーコード：${data.res}`);
      }
    },
    new_add () {
      this.$router.push({name: 'uUserInfoAdd', params: {}});
    },
    pass_reset () {
      this.$router.push({name: 'uPassReset', params: {}});
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
.user-login-box {
  text-align: center;
  padding-top: 65px;
  h1 {
    color: #1b2010;
    font-size: 28px;
    letter-spacing: 2px;
    margin-bottom: 30px;
  }
  .about {
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: #1d1b50;
    margin: 48px auto 20px auto;
    position: relative;
  }
  .about2 {
    margin-bottom: 0px;
  }
  .about3 {
    color: #1d1b50;
    margin-bottom: 20px;
  }
  input {
    ime-mode: inactive;
    height: 48px;
    font-size: 18px;
  }

  .login {
    position: relative;
    width: 400px;
    margin: 10px auto;
  }

  .control {
    margin-bottom: 17px;
  }

  .label {
    text-align: left;
    float: left;
    border-left: 6px solid #373863;
    color: #1d1b50;
    padding-left: 8px;
    margin-bottom: 5px;
  }

  .button {
    margin-top: 25px;
    width: 100%;
    height: 56px;
    color: #fefefe;
    border: initial;
    border-radius: 5px;
    font-size: 16px;
  }

  .help {
    color: #ff2626;
    font-size: 13px;
    line-height: 1.7;
  }

  @media (max-width: 767px) {
    padding-top: 25px;
    h1 {
      font-size: 20px;
      letter-spacing: 0px;
    }
    .login {
      width: calc(100vw - 110px);
      padding: 18px 15px 22px 15px;
    }
  }
}
</style>
